/**
 * Document metadata: identity and labels only. Runtime state lives in checkpoints ({ base, ui }) + event log.
 */
export class Document {
  readonly id: string
  private _name: string
  private _createdAt: Date
  private _modifiedAt: Date

  constructor(id?: string, name?: string) {
    this.id = id || crypto.randomUUID()
    this._name = name || 'Untitled'
    this._createdAt = new Date()
    this._modifiedAt = new Date()
  }

  static create(name?: string): Document {
    return new Document(undefined, name)
  }

  get name(): string {
    return this._name
  }
  set name(value: string) {
    this._name = value
    this._modifiedAt = new Date()
  }
  get createdAt(): Date { return this._createdAt }
  get modifiedAt(): Date { return this._modifiedAt }
  markModified(): void { this._modifiedAt = new Date() }

  getMetadata(): { id: string; name: string; createdAt: string; modifiedAt: string } {
    return { id: this.id, name: this._name, createdAt: this._createdAt.toISOString(), modifiedAt: this._modifiedAt.toISOString() }
  }
}
